import api from '../api'

export interface GlobalSearchParams {
  search: string
  page_size?: number
}

export interface SearchEmployeeResult {
  id: string
  first_name: string
  last_name: string
  email: string
  profile_picture?: string
  job_profile_name?: string
}

export interface SearchCandidateResult {
  id: string
  first_name: string
  last_name: string
  email: string
  position_name?: string
}

export interface SearchDocumentResult {
  id: string
  name: string
  template_name?: string
}

export interface SearchContentResult {
  id: string
  title: string
  topic?: string
}

export interface SearchJobProfileResult {
  id: string
  name: string
  department?: string
}

export const searchEmployees = async (search: string) => {
  const res = await api.get('/workforce/', {
    params: { search, page: 1, page_size: 5, minimal: true },
  })
  return res.data?.results ?? res.data ?? []
}

export const searchCandidates = async (search: string) => {
  const res = await api.get('/recruitment/candidates/', {
    params: { search, page: 1, page_size: 5, expand: 'position' },
  })
  return res.data?.results ?? res.data ?? []
}

export const searchDocuments = async (search: string) => {
  const res = await api.get('/documents/templates/', {
    params: { search, page: 1, page_size: 5 },
  })
  return res.data?.results ?? res.data ?? []
}

export const searchContent = async (search: string) => {
  const res = await api.get('/content/', {
    params: { search, page: 1, page_size: 5 },
  })
  return res.data?.results ?? res.data ?? []
}

export const searchJobProfiles = async (search: string) => {
  const res = await api.get('/classifications/job-profiles/', {
    params: { search, page: 1, page_size: 5 },
  })
  return res.data?.results ?? res.data ?? []
}
